<template>
    <section class="assign-package-panel tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-sm tw-overflow-hidden xl:tw-col-span-5">
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-b tw-border-gray-100 tw-bg-gray-50 tw-px-4 tw-py-3">
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-uppercase tw-text-gray-700">
                <span class="tw-inline-block tw-w-2 tw-h-2 tw-rounded-full tw-bg-blue-600"></span>
                {{ $t("assignDriver.selectedPackages") }}
                <span class="tw-inline-flex tw-h-5 tw-items-center tw-rounded-full tw-bg-blue-600 tw-px-2 tw-text-xs tw-font-bold tw-normal-case tw-text-white">
                    {{ records.length }} {{ $t("assignDriver.selected") }}
                </span>
            </div>
            <button
                class="tw-text-xs tw-font-bold tw-text-red-500 disabled:tw-opacity-50"
                type="button"
                :disabled="!records.length"
                @click.prevent="$emit('clear')"
            >
                {{ $t("assignDriver.removeAll") }}
            </button>
        </div>

        <div class="tw-border-b tw-border-gray-100 tw-px-4 tw-py-3">
            <div class="tw-text-xs tw-text-gray-500">
                {{ $t("assignDriver.totalAssignment") }}: <strong class="tw-text-gray-900">{{ totalPackages }} {{ $t("assignDriver.pkgs") }}</strong>
            </div>
        </div>

        <div class="tw-text-red-500 tw-text-xs tw-px-4 tw-pt-3" v-if="errors.has('booking_list_id')">
            {{ errors.first("booking_list_id") }}
        </div>

        <div class="selected-package-scroll tw-overflow-y-auto tw-divide-y tw-divide-gray-100">
            <div
                v-for="record in records"
                :key="record.booking_id"
                class="tw-flex tw-items-start tw-gap-3 tw-border-l-4 tw-border-blue-600 tw-px-4 tw-py-3"
            >
                <div class="tw-min-w-0 tw-flex-1">
                    <div class="tw-flex tw-items-start tw-justify-between tw-gap-3">
                        <div class="tw-min-w-0">
                            <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                                <span class="tw-text-xs tw-font-bold tw-text-blue-600">{{ record.booking_number }}</span>
                                <span :class="packageTypeClass(record)">{{ record.package_type_kh || record.package_type || '-' }}</span>
                                <span class="assign-info-chip">{{ record.number_of_package || 0 }} {{ $t("assignDriver.pkg") }}</span>
                                <span class="assign-info-chip tw-text-gray-500">{{ formatAmount(record.purchase_amount) }}</span>
                            </div>
                            <div class="tw-mt-1 tw-flex tw-min-w-0 tw-items-center tw-gap-2 tw-text-xs">
                                <span class="tw-font-normal tw-text-gray-400 tw-truncate">{{ record.shop_name || '-' }}</span>
                                <span class="tw-text-gray-300">•</span>
                                <span class="tw-flex-none tw-font-normal tw-text-gray-500">{{ formatDate(record.booking_time) }}</span>
                            </div>
                        </div>
                        <div class="tw-min-w-0 tw-text-right">
                            <div class="tw-text-xs tw-font-bold tw-text-gray-900 tw-whitespace-nowrap">{{ record.receiver_phone || '-' }}</div>
                            <div class="tw-mt-1 tw-text-xs tw-text-gray-400 tw-truncate tw-max-w-xs">{{ record.destination || '-' }}</div>
                        </div>
                    </div>
                </div>
                <button class="tw-flex-none tw-font-normal tw-text-gray-500 hover:tw-text-red-500" type="button" @click.prevent="$emit('delete', record)">
                    <i class="fa fa-times"></i>
                </button>
            </div>

            <div v-if="!records.length" class="tw-flex selected-package-empty tw-flex-col tw-items-center tw-justify-center tw-px-6 tw-py-10 tw-text-center">
                <div class="tw-mb-4 tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-blue-100 tw-bg-blue-50 tw-text-blue-600">
                    <a-icon type="inbox" class="tw-text-2xl" />
                </div>
                <div class="tw-text-sm tw-font-bold tw-text-gray-900">
                    {{ $t("assignDriver.noPackagesSelected") }}
                </div>
                <div class="tw-mt-2 tw-text-xs tw-leading-5 tw-text-gray-500">
                    {{ $t("assignDriver.noPackagesSelectedHint") }}
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import moment from "moment";

export default {
    name: "SelectedPackagesPanel",
    props: {
        records: {
            type: Array,
            default: () => []
        },
        totalPackages: {
            type: Number,
            default: 0
        },
        errors: {
            required: true
        }
    },
    methods: {
        formatAmount(value) {
            const amount = Number(value || 0);

            return "$ " + amount.toFixed(2);
        },
        formatDate(value) {
            if (!value) {
                return "-";
            }

            const date = moment(value);

            return date.isValid() ? date.format("DD-MM-YYYY") : value;
        },
        packageTypeClass(record) {
            const type = String(record.package_type_kh || record.package_type || "").toLowerCase();
            const base = "tw-inline-flex tw-items-center tw-rounded tw-border tw-px-2 tw-py-1 tw-text-xs tw-font-normal tw-whitespace-nowrap";

            if (type.indexOf("express") !== -1) {
                return base + " tw-border-blue-200 tw-bg-blue-50 tw-text-blue-600";
            }

            if (type.indexOf("fragile") !== -1) {
                return base + " tw-border-red-200 tw-bg-red-50 tw-text-red-500";
            }

            if (type.indexOf("heavy") !== -1) {
                return base + " tw-border-indigo-200 tw-bg-indigo-50 tw-text-indigo-600";
            }

            if (type.indexOf("standard") !== -1) {
                return base + " tw-border-gray-200 tw-bg-gray-50 tw-text-gray-700";
            }

            return base + " tw-border-yellow-200 tw-bg-yellow-50 tw-text-yellow-700";
        }
    }
};
</script>
